<template>
  <v-container fluid class="px-6 py-6">
    <v-row justify="center" align="center" class="min-height-screen">
      <v-col cols="12" md="8" lg="6">
        <v-card class="text-center pa-8" elevation="4">
          <v-card-title class="justify-center pb-4">
            <v-icon large color="primary" class="mr-3">qr_code_scanner</v-icon>
            <span class="text-h4 font-weight-bold">Ticket-Scanner</span>
          </v-card-title>
          
          <v-divider class="my-6"></v-divider>
          
          <v-card-text>
            <p class="text-h6 mb-4 text--primary">
              Du hast Scanner-Berechtigung
            </p>
            <p class="text-body-1 mb-6 text--secondary">
              Der Ticket-Scanner ist nur in der mobilen App verfügbar. Bitte logge dich in der App ein, um Tickets zu scannen.
            </p>
            
            <v-alert
              type="info"
              border="left"
              colored-border
              elevation="2"
              class="text-left"
            >
              <div class="d-flex align-center">
                <v-icon class="mr-3">info</v-icon>
                <div>
                  <strong>Hinweis:</strong> Die Scanner-Funktion ist für die mobile App vorgesehen. 
                  Im Web-Interface stehen dir diese Funktionen nicht zur Verfügung.
                </div>
              </div>
            </v-alert>
            
            <v-btn
              color="primary"
              large
              class="mt-6"
              @click="$router.push('/').catch(() => {})"
            >
              <v-icon left>home</v-icon>
              Zur Startseite
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ScannerInfo',
  mounted() {
    // Redirect if user is not a checker
    if (!this.$store.getters.isChecker) {
      this.$router.push('/admin/analytics').catch(() => {});
    }
  }
};
</script>

<style scoped>
.min-height-screen {
  min-height: calc(100vh - 200px);
}
</style>
